var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-booking",
    transform: "translate(-40 -200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_35",
    "data-name": "Ret\\xE2ngulo 35",
    transform: "translate(40 200)",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_19",
    "data-name": "Caminho 19",
    d: "M15.3,19.875l-2.438-2.66L13.9,16.186,15.3,17.6l3.183-3.183,1.029,1.25L15.3,19.875m-9.531-.142A1.773,1.773,0,0,1,4,17.96V3.773A1.767,1.767,0,0,1,5.773,2H6.66V8.207l2.217-1.33,2.217,1.33V2h5.32a1.773,1.773,0,0,1,1.773,1.773v8.281a5.327,5.327,0,0,0-7.093,5.018,5.3,5.3,0,0,0,.709,2.66Z",
    transform: "translate(38.242 199.143)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.c57830d55b6af8dfdc850d1bfa2af176.svg";
export { ForwardRef as ReactComponent };